import React, {useState, useRef} from 'react';
import {connect, WithStore, MapStateToProps, MapDispatchToProps} from '../../redux/services/Imports';
import './FormVacancy.scss';
import './FormVacancy-media.scss';
import {Props} from './interfaces';
import Input from '../Input/Input';
import InputPhone from '../Input/InputPhone';
import {ValidationFormItems} from '../../services/GlobalFunctions';
import ErrorText from '../ErrorText/ErrorText';
import Button from '../Button/Button';
import {ServiceData} from '../../redux/services/ServiceRedux';
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';
import ErrorTextBlocked from '../ErrorTextBlocked/ErrorTextBlocked';
import {CSSTransition} from 'react-transition-group';
import SuccessContent from '../SuccessContent/SuccessContent';
import AgreementCheckboxes from "../AgreementCheckboxes/AgreementCheckboxes";

const FormVacancy = ({
                       vacancyTitle = '',
                       blockedSend,
                       blockedSendLoaded,
                       contactForms
                     }: Props) => {


  const [name, setName] = useState('');
  const [phone, setPhone] = useState('+7');
  const [successShow, setSuccessShow] = useState(false);
  const [errorName, setErrorName] = useState<string | null>(null);
  const [errorPhone, setErrorPhone] = useState<string | null>(null);
  const [serverText, setServerText] = useState<string | null>(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);

  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
  const [allowMarketing, setAllowMarketing] = useState(false);

  const success = () => {
    setName('');
    setPhone('+7');
    setSuccessShow(true);
    setTimeout(() => setSuccessShow(false), 3000);
    setDisableBtn(false);
    setPrivacyPolicyAccepted(false);
    setAllowMarketing(false);
    setErrorName(null);
    setErrorPhone(null);
    setServerText(null);
  };

  const {executeRecaptcha} = useGoogleReCaptcha();

  const handleReCaptchaVerify = async (e: any) => {
    e.preventDefault();
    setDisableBtn(true);
    setErrorName(null);
    setErrorPhone(null);
    setServerText(null);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    // v3
    let token = '';
    if (!executeRecaptcha) {
      console.debug('recaptcha not set, ignoring');
    } else {
      token = await executeRecaptcha('page_vacancy_submit');
    }

    if (!ValidationFormItems({phone, setErrorPhone})) {
      setDisableBtn(false);
      return;
    }
    ServiceData.submitForm({
      data: {
        name,
        phone,
        allowMarketing
      },
      success,
      setServerText,
      token,
      eventMetrika: 'form_job',
      contactFormId: contactForms.vacancy_contact_form_id
    });
  };

  const nodeRefSuccess = useRef(null);
  const nodeRef = useRef(null);

  return (
    <div className="form-vacancy">
      <div className="form-vacancy__block-for-bg">
        <div className="form-vacancy__bg-4"></div>
        <div className="form-vacancy__info">
          <CSSTransition
            in={successShow}
            nodeRef={nodeRefSuccess}
            timeout={{appear: 200, enter: 0, exit: 200}}
            classNames="css-transition-modal"
            unmountOnExit
          >
            <SuccessContent refCss={nodeRefSuccess}/>
          </CSSTransition>

          <CSSTransition
            in={!successShow}
            nodeRef={nodeRef}
            timeout={{appear: 200, enter: 0, exit: 0}}
            classNames="css-transition-content"
            unmountOnExit
          >
            <>
              <h3>Станьте частью команды Dalli</h3>
              <form className="form-vacancy__form" onSubmit={handleReCaptchaVerify}>
                <div className={'form-vacancy__form-container'}>
                  <Input
                    label="Имя"
                    name="name"
                    value={name}
                    onChange={(e: any) => {
                      setName(e.target.value);
                      if (errorName) setErrorName(null);
                      if (serverText) setServerText(null);
                    }}
                    error={errorName}
                  />
                  <InputPhone
                    label="Телефон*"
                    name="phone"
                    value={phone}
                    onChange={(e: any) => {
                      setPhone(e.target.value);
                      if (errorPhone) setErrorPhone(null);
                      if (serverText) setServerText(null);
                    }}
                    error={errorPhone}
                  />

                  {showBlockedError && blockedSend.state && (
                    <div className="form-vacancy__error-blocked">
                      <ErrorTextBlocked counter={blockedSend.counter}/>
                    </div>
                  )}


                  <div className="form-vacancy__form-button">
                    {serverText && !errorName && !errorPhone ? ErrorText(serverText) : null}
                    <Button
                      text="Отправить заявку"
                      size="M"
                      widthAll
                      disabled={disableBtn || !privacyPolicyAccepted}
                      showBlockedError={showBlockedError}
                    />

                  </div>
                </div>
                <AgreementCheckboxes
                  privacyChecked={privacyPolicyAccepted}
                  onPrivacyChange={setPrivacyPolicyAccepted}
                  marketingChecked={allowMarketing}
                  onMarketingChange={setAllowMarketing}
                />
              </form>
            </>
          </CSSTransition>
        </div>
      </div>
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(FormVacancy));
